import { useState, useEffect, useRef } from "react";
import "./styles/generales.css";
import InternalError from "../generales/InternalError";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
import { Line } from 'react-chartjs-2';
import ModalHostLisGenerals from "./ModalHostLisGenerals";
import Modal from 'react-modal';
import useAlarmSound from './useAlarmSound';
import useAlarmVoice from "./Usealarmvoice";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import LoadSimple from "../LoadSimple";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const hostListModalStyles = {
    content: {
        top: "50%",
        left: "50%",
        background: "#ffffff !important",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        width: "50%",
        height: "90%",
        padding: "20px",
    },
};

const General = ({ handleShowPopup, server, languaje, mode }) => {
    const token_item = localStorage.getItem("access_token");
    const [chartData, setChartData] = useState({ labels: [], datasets: [] });
    const [dataAnalisis, setDataAnalisis] = useState({
        data: [],
        loading: true,
        error: {},
    });
    const [dataHistoric, setDataHistoric] = useState({
        data: {},
        loading: true,
        error: {},
    });
    const [hostsListModalOpen, setHostsListModalOpen] = useState(false);
    const [userSelected, setUserSelected] = useState({});
    const [source, setSource] = useState("");
    const [prevData, setPrevData] = useState([]);
    const animationRefs = useRef({});
    const [responseDataAll, setResponseDataAll] = useState({});
    const [responseDataFiltered, setResponseDataFiltered] = useState({});
    const [hostsInException, setHostsInException] = useState(0);
    const [showExceptions, setShowExceptions] = useState(false);

    function openHostsListModal() {
        setHostsListModalOpen(true);
    }

    function closHostsListModal() {
        setHostsListModalOpen(false);
    }

    const handleHostLisClick = (data, source) => {
        setSource(source);
        openHostsListModal();
        setUserSelected(data);
    };

    async function search_historic() {
        setDataHistoric({ data: {}, loading: true, error: dataHistoric.error });
        try {
            const response = await fetch(
                server.url + "/api/v1/cassia/dashboard/availability_optimized",
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token_item}`,
                    },
                }
            );

            if (response.ok) {
                const response_data = await response.json();
                const all = response_data.all?.metrics?.[0] || {};
                const filtered = response_data.filtered?.metrics?.[0] || {};
                const exception_hosts =
                    (all.device_count?.[0] || 0) - (filtered.device_count?.[0] || 0);

                setResponseDataAll(response_data.all);
                setResponseDataFiltered(response_data.filtered);
                setHostsInException(exception_hosts);

                const datasets = [
                    {
                        label: capitalizeFirstLetter(lang[languaje]["disponibilidad"]),
                        data: filtered.dataset?.map((obj) => obj.Disponibilidad) || [],
                        borderColor: "#00adb5",
                        backgroundColor: "rgba(0,173,181,0.2)",
                        tension: 0.4,
                        pointRadius: 3,
                    },
                    {
                        label: `Disponibilidad considerando hosts en exepcion`,
                        data: all.dataset?.map((obj) => obj.Disponibilidad) || [],
                        borderColor: "#8a9aa8",
                        backgroundColor: "rgba(138,154,168,0.15)",
                        tension: 0.4,
                        pointRadius: 3,
                        borderDash: [5, 3],
                    },
                ];

                const labels =
                    all.dataset?.map((obj) => obj.Tiempo) ||
                    filtered.dataset?.map((obj) => obj.Tiempo) ||
                    [];

                setChartData({ labels, datasets });
                setDataHistoric({
                    data: { all, filtered, exception_hosts },
                    loading: false,
                    error: dataHistoric.error,
                });
            } else {
                throw new Error("Error en la solicitud");
            }
        } catch (error) {
            console.error("Error obteniendo histórico", error);
            setDataHistoric({ data: {}, loading: false, error });
        }
    }

    async function search_analisis() {
        setDataAnalisis({ data: [], loading: true, error: dataAnalisis.error });
        try {
            const response = await fetch(server.url + "/api/v1/cassia/dashboard/hosts", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token_item}`,
                },
            });
            if (response.ok) {
                const response_data = await response.json();
                setDataAnalisis({
                    data: response_data.data,
                    loading: false,
                    error: dataAnalisis.error,
                });
            } else {
                throw new Error("Error en la solicitud");
            }
        } catch (error) {
            console.error("Error obteniendo análisis", error);
        }
    }

    useEffect(() => {
        search_analisis();
        search_historic();
        const interval = setInterval(() => {
            search_historic();
        }, 30000);
        return () => clearInterval(interval);
    }, []);

    const { playAlarm, stopAlarm } = useAlarmSound({ type: 'medical', volume: 0.5 });
    const { speak, stopVoice } = useAlarmVoice({ pitch: 0.5, rate: 0.8, repeat: false });

    useEffect(() => {
        if (prevData.length && dataAnalisis.data.length) {
            let huboDecrease = false;
            let text = '';
            dataAnalisis.data.forEach((element, index) => {
                const prevElement = prevData[index];
                if (prevElement) {
                    const ref = animationRefs.current[index];
                    if (ref && prevElement.active !== element.active) {
                        const isIncreasing = element.active > prevElement.active;
                        const animClass = isIncreasing ? 'animate-increase' : 'animate-decrease';
                        ref.classList.add(animClass);
                        setTimeout(() => ref.classList.remove(animClass), 3000);
                        if (!isIncreasing) {
                            huboDecrease = true;
                            text = element.tech;
                        }
                    }
                }
            });
            if (huboDecrease) {
                speak('Alerta crítica: host caído en ' + text);
            }
        }
        setPrevData([...dataAnalisis.data]);
    }, [dataAnalisis]);

    return (
        <>
            <style>{`
                @keyframes pulse-increase {
                    0%, 100% { transform: scale(1); }
                    50% { transform: scale(1.05); }
                }
                @keyframes pulse-decrease {
                    0%, 100% { transform: scale(1); }
                    50% { transform: scale(0.95); }
                }
                .animate-increase {
                    animation: pulse-increase 0.6s ease-in-out;
                }
                .animate-decrease {
                    animation: pulse-decrease 0.6s ease-in-out;
                }
            `}</style>

            <div style={{
                width: '95%',
                height: '92%',
                padding: '2%',
                fontFamily: "'DM Sans', system-ui, sans-serif",
                background: mode === 'Dark' ? '#0f172a' : '#f8fafc',
                overflowY: 'auto'
            }}>

                {/* ── SECCIÓN: INDICADORES POR TECNOLOGÍA ── */}
                <div style={{
                    marginBottom: 32,
                    background: mode === 'Dark' ? '#1e293b' : '#fff',
                    borderRadius: 12,
                    padding: '24px',
                    border: '1px solid #e2e8f0'
                }}>
                    <h2 style={{
                        fontSize: 16,
                        fontWeight: 600,
                        color: mode === 'Dark' ? '#f1f5f9' : '#0f2d5e',
                        marginBottom: 20,
                        textAlign: 'center'
                    }}>
                        {capitalizeFirstLetter(lang[languaje]["indicadoresportecnologia"])}
                    </h2>

                    {dataAnalisis.loading ? (
                        <div style={{
                            width: '100%',
                            height: '200px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <LoadSimple />
                        </div>
                    ) : (
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                            gap: 20
                        }}>
                            {dataAnalisis.data.map((element, index) => (
                                <div
                                    key={index}
                                    ref={(el) => (animationRefs.current[index] = el)}
                                    style={{
                                        background: mode === 'Dark' ? '#334155' : '#fff',
                                        border: '1px solid #e2e8f0',
                                        borderRadius: 10,
                                        padding: '20px',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                        transition: 'transform 0.2s, box-shadow 0.2s'
                                    }}
                                    onMouseEnter={e => {
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.12)';
                                    }}
                                    onMouseLeave={e => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.08)';
                                    }}
                                >
                                    {/* Título tecnología */}
                                    <div style={{
                                        fontSize: 13,
                                        fontWeight: 600,
                                        color: mode === 'Dark' ? '#f1f5f9' : '#334155',
                                        textAlign: 'center',
                                        marginBottom: 16,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    }}>
                                        {element.tech}
                                    </div>

                                    {/* Stats */}
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-around',
                                        alignItems: 'center'
                                    }}>
                                        {/* EN LÍNEA */}
                                        <div style={{ textAlign: 'center' }}>
                                            <div style={{
                                                fontSize: 10,
                                                fontWeight: 500,
                                                color: '#057a55',
                                                marginBottom: 6,
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.06em'
                                            }}>
                                                {lang[languaje]["enLinea"]}
                                            </div>
                                            <div style={{
                                                fontSize: 32,
                                                fontWeight: 700,
                                                color: '#057a55',
                                                fontFamily: "'DM Mono', monospace"
                                            }}>
                                                {element.active}
                                            </div>
                                        </div>

                                        {/* FUERA DE LÍNEA */}
                                        <div style={{ textAlign: 'center' }}>
                                            <div style={{
                                                fontSize: 10,
                                                fontWeight: 500,
                                                color: '#db2777',
                                                marginBottom: 6,
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.06em'
                                            }}>
                                                {lang[languaje]["fueraLinea"]}
                                            </div>
                                            <div style={{
                                                fontSize: 32,
                                                fontWeight: 700,
                                                color: '#db2777',
                                                fontFamily: "'DM Mono', monospace"
                                            }}>
                                                {element.inactive}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* ── SECCIÓN: INDICADORES GENERALES ── */}
                <div style={{
                    marginBottom: 32,
                    background: mode === 'Dark' ? '#1e293b' : '#fff',
                    borderRadius: 12,
                    padding: '24px',
                    border: '1px solid #e2e8f0'
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 12,
                        marginBottom: 24
                    }}>
                        <h2 style={{
                            fontSize: 16,
                            fontWeight: 600,
                            color: mode === 'Dark' ? '#f1f5f9' : '#0f2d5e',
                            margin: 0
                        }}>
                            {capitalizeFirstLetter(lang[languaje]["indicadorsGeneral"])}
                        </h2>

                        {/* Toggle Excepciones */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10
                        }}>
                            <label style={{
                                position: 'relative',
                                display: 'inline-block',
                                width: 44,
                                height: 24,
                                cursor: 'pointer'
                            }}>
                                <input
                                    type="checkbox"
                                    checked={showExceptions}
                                    onChange={(e) => setShowExceptions(e.target.checked)}
                                    style={{ display: 'none' }}
                                />
                                <span style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    background: showExceptions ? '#1a56db' : '#cbd5e1',
                                    borderRadius: 24,
                                    transition: 'background 0.3s'
                                }}>
                                    <span style={{
                                        position: 'absolute',
                                        content: '',
                                        height: 18,
                                        width: 18,
                                        left: showExceptions ? 23 : 3,
                                        bottom: 3,
                                        background: '#fff',
                                        borderRadius: '50%',
                                        transition: 'left 0.3s',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                    }} />
                                </span>
                            </label>
                            <span style={{
                                fontSize: 12,
                                fontWeight: 500,
                                color: showExceptions ? (mode === 'Dark' ? '#f1f5f9' : '#334155') : '#9ca3af',
                                transition: 'color 0.3s'
                            }}>
                                {capitalizeFirstLetter(lang[languaje]['mostrarExcepciones'])}
                            </span>
                        </div>
                    </div>

                    {dataHistoric.loading ? (
                        <div style={{
                            width: '100%',
                            height: '150px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <LoadSimple />
                        </div>
                    ) : (
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                            gap: 20
                        }}>
                            {/* Disponibilidad con excepciones */}
                            {showExceptions && (
                                <div style={{
                                    background: mode === 'Dark' ? '#334155' : '#f8fafc',
                                    border: '1px solid #e2e8f0',
                                    borderRadius: 10,
                                    padding: '20px',
                                    textAlign: 'center'
                                }}>
                                    <div style={{
                                        fontSize: 11,
                                        fontWeight: 500,
                                        color: mode === 'Dark' ? '#cbd5e1' : '#64748b',
                                        marginBottom: 12,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 6
                                    }}>
                                        Disponibilidad considerando hosts en excepción
                                        <div style={{
                                            position: 'relative',
                                            display: 'inline-block',
                                            cursor: 'help'
                                        }}>
                                            <div style={{
                                                width: 16,
                                                height: 16,
                                                borderRadius: '50%',
                                                background: '#94a3b8',
                                                color: '#fff',
                                                fontSize: 10,
                                                fontWeight: 600,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                i
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{
                                        fontSize: 36,
                                        fontWeight: 700,
                                        color: '#8a9aa8',
                                        fontFamily: "'DM Mono', monospace",
                                        marginBottom: 6
                                    }}>
                                        {responseDataAll?.metrics?.[0]?.availability_average?.[0]
                                            ? (responseDataAll.metrics[0].availability_average[0] * 1).toFixed(2) + " %"
                                            : "0 %"}
                                    </div>
                                    <div style={{
                                        fontSize: 12,
                                        color: '#64748b'
                                    }}>
                                        ({responseDataAll?.metrics?.[0]?.device_count?.[0] || 0} hosts)
                                    </div>
                                </div>
                            )}

                            {/* Disponibilidad */}
                            <div style={{
                                background: mode === 'Dark' ? '#334155' : '#f8fafc',
                                border: '1px solid #e2e8f0',
                                borderRadius: 10,
                                padding: '20px',
                                textAlign: 'center'
                            }}>
                                <div style={{
                                    fontSize: 11,
                                    fontWeight: 500,
                                    color: mode === 'Dark' ? '#cbd5e1' : '#64748b',
                                    marginBottom: 12,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 6
                                }}>
                                    Disponibilidad
                                    <div style={{
                                        position: 'relative',
                                        display: 'inline-block',
                                        cursor: 'help'
                                    }}>
                                        <div style={{
                                            width: 16,
                                            height: 16,
                                            borderRadius: '50%',
                                            background: '#00adb5',
                                            color: '#fff',
                                            fontSize: 10,
                                            fontWeight: 600,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            i
                                        </div>
                                    </div>
                                </div>
                                <div style={{
                                    fontSize: 36,
                                    fontWeight: 700,
                                    color: '#00adb5',
                                    fontFamily: "'DM Mono', monospace",
                                    marginBottom: 6
                                }}>
                                    {responseDataFiltered?.metrics?.[0]?.availability_average?.[0]
                                        ? (responseDataFiltered.metrics[0].availability_average[0] * 1).toFixed(2) + " %"
                                        : "0 %"}
                                </div>
                                <div style={{
                                    fontSize: 12,
                                    color: '#00adb5'
                                }}>
                                    ({responseDataFiltered?.metrics?.[0]?.device_count?.[0] || 0} hosts)
                                </div>
                            </div>

                            {/* Hosts en Excepción */}
                            <div style={{
                                background: mode === 'Dark' ? '#334155' : '#f8fafc',
                                border: '1px solid #e2e8f0',
                                borderRadius: 10,
                                padding: '20px',
                                textAlign: 'center'
                            }}>
                                <div style={{
                                    fontSize: 11,
                                    fontWeight: 500,
                                    color: mode === 'Dark' ? '#cbd5e1' : '#64748b',
                                    marginBottom: 12
                                }}>
                                    Hosts en Excepción
                                </div>
                                <div style={{
                                    fontSize: 36,
                                    fontWeight: 700,
                                    color: '#7e3af2',
                                    fontFamily: "'DM Mono', monospace"
                                }}>
                                    {hostsInException || 0}
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* ── SECCIÓN: GRÁFICA ORIGINAL ── */}
                <div className="cont-grafica-monitor">
                    <div className="compact-grafica-monitor">
                        <div className="grafica-header-info">
                            Últimas 12 horas {"("}
                            {responseDataAll?.metrics?.[0]?.first_data?.[0]?.slice(11, 16)} - {" "}
                            {responseDataAll?.metrics?.[0]?.last_data?.[0]?.slice(11, 16)}
                            {")"}
                        </div>

                        <Line
                            data={{
                                ...chartData,
                                datasets: chartData.datasets.map((dataset) => {
                                    if (dataset.label.includes("exepcion")) {
                                        return { ...dataset, hidden: !showExceptions };
                                    }
                                    return dataset;
                                }),
                            }}
                            style={{ width: "100%", height: "100%" }}
                            options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                    legend: { display: true, position: "top" },
                                },
                            }}
                        />
                    </div>
                </div>

            </div>

            <Modal
                isOpen={hostsListModalOpen}
                onRequestClose={closHostsListModal}
                style={hostListModalStyles}
                contentLabel="Example Modal2"
            >
                <ModalHostLisGenerals
                    source={source}
                    handleShowPopup={handleShowPopup}
                    languaje={languaje}
                    mode={mode}
                    server={server}
                    brand={userSelected}
                    closHostsListModal={closHostsListModal}
                />
            </Modal>
        </>
    );
};

export default General;